import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr } from "../../lib/api";
import { PageHeader, btnPrimary, EmptyState } from "../../components/bits";
import { Plus } from "lucide-react";
import { ChallengeCard } from "../../components/admin/ChallengeCard";
import { ChallengeFormModal, WinnerModal } from "../../components/admin/ChallengeModals";

const emptyCh = { title: "", description: "", week_start: "", week_end: "" };

export default function AdminChallenges() {
  const [challenges, setChallenges] = useState(null);
  const [schools, setSchools] = useState([]);
  const [modal, setModal] = useState(false);
  const [winnerModal, setWinnerModal] = useState(null);
  const [winnerId, setWinnerId] = useState("");
  const [form, setForm] = useState(emptyCh);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => api.get("/admin/challenges").then((r) => setChallenges(r.data)).catch((e) => toast.error(fmtErr(e))), []);
  useEffect(() => {
    load();
    api.get("/admin/schools").then((r) => setSchools(r.data.map((s) => ({ id: s.school.id, name: s.school.name })))).catch(() => {});
  }, [load]);

  const save = async () => {
    setBusy(true);
    try {
      await api.post("/admin/challenges", form);
      toast.success("تم نشر التحدي وإشعار جميع المنسقين");
      setModal(false);
      setForm(emptyCh);
      load();
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setBusy(false);
    }
  };

  const closeWithWinner = async () => {
    if (!winnerId) {
      toast.error("اختر المدرسة الفائزة");
      return;
    }
    setBusy(true);
    try {
      await api.put(`/admin/challenges/${winnerModal.id}`, {
        title: winnerModal.title, description: winnerModal.description,
        week_start: winnerModal.week_start, week_end: winnerModal.week_end,
        status: "closed", winner_school_id: winnerId,
      });
      toast.success("تم إغلاق التحدي وإشعار منسق المدرسة الفائزة");
      setWinnerModal(null);
      load();
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("حذف هذا التحدي؟")) return;
    await api.delete(`/admin/challenges/${id}`);
    toast.success("تم الحذف");
    load();
  };

  if (!challenges) return <div className="text-center text-mutext py-20 font-head">جارٍ التحميل …</div>;

  return (
    <div data-testid="admin-challenges-page">
      <PageHeader title="التحديات الأسبوعية" sub="انشر تحدياً ليصل إشعاره فوراً لجميع المنسقين، ثم توّج المدرسة الفائزة">
        <button data-testid="challenge-add-btn" onClick={() => setModal(true)} className={btnPrimary}>
          <Plus className="w-4 h-4" /> تحدٍّ جديد
        </button>
      </PageHeader>

      {challenges.length === 0 ? (
        <EmptyState testid="admin-challenges-empty" text="لا توجد تحديات بعد" />
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {challenges.map((ch) => (
            <ChallengeCard key={ch.id} ch={ch}
              onCrown={(c) => { setWinnerModal(c); setWinnerId(""); }} onDelete={remove} />
          ))}
        </div>
      )}

      <ChallengeFormModal open={modal} onClose={() => setModal(false)} form={form} setForm={setForm} busy={busy} onSave={save} />
      <WinnerModal challenge={winnerModal} schools={schools} winnerId={winnerId} setWinnerId={setWinnerId}
        busy={busy} onSave={closeWithWinner} onClose={() => setWinnerModal(null)} />
    </div>
  );
}
